import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';

const actions = {
  async searchTransporter(_, params) {
    try {
      const result = await axios.get('settings/transporter', { params });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async updateTransitDelayConfig(_, payload) {
    try {
      const result = await axios.put('settings/transit-delay-config', { data: payload });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getTransitDelayConfig({ commit }) {
    try {
      const result = await axios('settings/transit-delay-config');
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getPenaltyRules({ commit }) {
    try {
      const result = await axios('settings/transit-delay');
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getPenaltyRuleById(_, params) {
    try {
      const result = await axios(`settings/transit-delay/${params.ruleId}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async saveTransitPenalty(_, payload) {
    try {
      const result = await axios.post('settings/transit-delay', { data: payload });
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async updateTransitPenalty(_, payload) {
    try {
      const result = await axios.put('settings/transit-delay', { data: payload });
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async deletePenaltyRuleById(_, params) {
    try {
      const result = await axios.delete(`settings/transit-delay/${params.ruleId}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
};

export default actions;
